import CaseCreateEditorModal from "@/components/cases/case-create-editor-modal";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuShortcut,
	DropdownMenuTrigger,
} from "@/components/core/actions/dropdown-menu";
import { Blanket, BlanketInfo } from "@/components/core/blanket.tsx";
import { Button } from "@/components/core/buttons/button";
import { useModal } from "@/components/core/modals/use-modal";
import Tooltip from "@/components/core/tooltip";
import {
	IconChevronDown,
	IconCommand,
	IconDownload,
	IconEye,
	IconFile,
	IconFileTypePdf,
	IconFileUpload,
	IconPlus,
	IconPrinter,
	IconTrash,
} from "@tabler/icons-react";
import { Link } from "@tanstack/react-router";
import { useState } from "react";

export default function CaseCustomAttachments({
	title = "Payment Receipts",
	hasAttachments,
}: {
	title: string;
	hasAttachments: boolean;
	counts: number;
}) {
	const [hasAttachment, setHasAttachment] = useState(hasAttachments);
	const [files, setFiles] = useState<{ name: string }[]>([]);
	const modal = useModal();

	const handleAddAttachments = () => {
		setHasAttachment(false);
	};

	const handleDelete = (index: number) => {
		setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
	};

	return (
		<div className="flex flex-col w-full rounded-md border border-border/50 overflow-hidden">
			<div className="flex flex-row items-center justify-between w-full p-4 gap-4 bg-slate-50">
				<span className="text-base font-semibold">{title}</span>
				<DropdownMenu modal={false}>
					<DropdownMenuTrigger asChild>
						<Button>
							<span className="">Add</span>
							<IconChevronDown size={18} stroke={2} />
						</Button>
					</DropdownMenuTrigger>
					<DropdownMenuContent align="start" sideOffset={8}>
						<DropdownMenuGroup>
							<DropdownMenuItem
								onClick={async () => {
									const newFile = { name: "created-document.docx" };
									setFiles((prevFiles) => [...prevFiles, newFile]);
									const modalId = modal.openModal({
										allowClose: false,
										title: "Create File",
										description:
											"Yes, this is for the description, Please make it short",
										size: "full",
										showHeader: false,
										showFooter: false,
										component: (
											<CaseCreateEditorModal
												handleSubmit={async (values) => {
													modal.closeModal(modalId);
												}}
											/>
										),
									});
								}}
							>
								<div className="flex flex-row items-center w-full py-1 px-2">
									Create File
									<DropdownMenuShortcut>
										<IconFile size={18} stroke={1.5} />
									</DropdownMenuShortcut>
								</div>
							</DropdownMenuItem>
							<DropdownMenuItem>
								<div className="flex flex-row items-center w-full py-1 px-2">
									<label
										htmlFor="user-photo"
										className="w-full cursor-pointer z-10 flex flex-row items-center"
									>
										Attach File
									</label>
									<input
										id="user-photo"
										name="user-photo"
										type="file"
										accept="image/*"
										onClick={async () => {
											const newFile = { name: "sample-document.pdf" };
											setFiles((prevFiles) => [...prevFiles, newFile]);
										}}
										className="absolute inset-0 h-full w-full cursor-pointer rounded-md border-gray-300 opacity-0"
									/>
									<DropdownMenuShortcut>
										<IconFileUpload size={18} stroke={1.5} />
									</DropdownMenuShortcut>
								</div>
							</DropdownMenuItem>
						</DropdownMenuGroup>
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
			<div className="flex flex-col w-full p-4 gap-2">
				{files.length !== 0 ? (
					<div className="flex flex-col w-full gap-2">
						{files.map((data, index) => (
							<div key={data.name} className="flex flex-row w-full gap-2">
								<div className="inline-flex justify-center items-center w-[50px] h-[50px] rounded-md bg-red-500 text-white">
									<IconFileTypePdf size={24} stroke={1.5} />
								</div>
								<div className="inline-flex flex-col w-auto">
									<Link
										to="#"
										className="text-base font-semibold text-blue-600 hover:text-blue-500"
									>
										{data.name}
									</Link>
									<span className="text-sm text-foreground/70">
										Uploaded on Jan 1, 2025
									</span>
									<span className="text-sm text-foreground/70">25 KB</span>
								</div>
								<div className="inline-flex w-auto gap-3 ml-auto">
									<div className="inline-flex flex-row w-auto gap-1">
										<Tooltip content="Download" side="top">
											<Button size="icon" variant="ghost">
												<IconDownload size={16} stroke={2} />
											</Button>
										</Tooltip>
										<Tooltip content="Preview" side="top">
											<Button size="icon" variant="ghost">
												<IconEye size={16} stroke={2} />
											</Button>
										</Tooltip>
										<Tooltip content="Print" side="top">
											<Button size="icon" variant="ghost">
												<IconPrinter size={16} stroke={2} />
											</Button>
										</Tooltip>
									</div>
									<Tooltip content="Remove" side="top">
										<Button
											size="icon"
											variant="danger"
											onClick={() => handleDelete(index)}
										>
											<IconTrash size={16} stroke={2} />
										</Button>
									</Tooltip>
								</div>
							</div>
						))}
					</div>
				) : (
					<Blanket width="sm">
						<BlanketInfo
							title="No Data"
							message="No available data for now. Please check back later or refresh the page."
						/>
					</Blanket>
				)}
			</div>
		</div>
	);
}
